class PriceListService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getPage(params) {
    return this.apiService.get('/api/v1/pricelist', params);
  }
}

export default PriceListService;
